// TODO: This is a placeholder for now until we have more clarity on how MOR types will be used in the system.
export enum MonthlyOperatingReportCategory {
  DrinkingWater = "Drinking Water",
  Wastewater = "Wastewater",
  Stormwater = "Stormwater",
  LeadCopper = "Lead & Copper Rule (LCR)",
  DisinfectionByproducts = "Disinfection Byproducts (DBP)",
  ConsumerConfidenceReport = "Consumer Confidence Report (CCR)",
  Other = "Other",
}
